module.exports = __webpack_public_path__ + "img/telegram.3be6bef4.svg";